module.exports = __webpack_public_path__ + "components/star-rating/static/white/1-f8499554f6059245d3e7187a50b9fc07.svg";